<template>
  <b-card
    :title="title"
    :loading="loading"
    :error-message="errorMessage"
    :disabled="!formValid"
    @cancel="$emit('cancel')"
    @submit="mode === 'create' ? submit() : updateSubscription()"
    :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
    :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
  >
    <v-row no-gutters>
      <v-col cols="12" class="pl-2">
        <b-text-field
          v-model="subscriptionPlan.plan_name[nameLang]"
          :label="translations.planName[lang]"
          :success="success.plan_name"
          :error-messages="error.plan_name"
          @blur="validatePlanName"
        >
          <template v-slot:append>
            <b-lang-menu v-model="nameLang" type="inner"></b-lang-menu>
          </template>
        </b-text-field>

        <b-textarea
          :label="translations.planDescription[lang]"
          v-model="subscriptionPlan.plan_description[descriptionLang]"
          :success="success.plan_description"
          :error-messages="error.plan_description"
          @focus="error.plan_description = ''"
          @blur="validatePlanDescription"
        >
          <template v-slot:append>
            <b-lang-menu v-model="descriptionLang" type="inner"></b-lang-menu>
          </template>
        </b-textarea>

        <b-text-field
          v-model="subscriptionPlan.plan_price"
          :label="translations.planPrice[lang]"
          :success="success.plan_price"
          :error-messages="error.plan_price"
          @focus="error.plan_price = ''"
          @blur="validatePlanPrice"
        >
          <!-- <template v-slot:append>
                    <v-checkbox
                    v-model="subscriptionPlan.vat_included"
                    color="secondary"
                    class="mt-0 pt-0 pb-0 mr-0"
                    hide-details
                >
                <template v-slot:label>
                    
                    <span class="mt-0 ">vat_included</span>
                </template></v-checkbox>
                </template> -->
        </b-text-field>
        <v-checkbox
          v-model="subscriptionPlan.vat_included"
          color="secondary"
          class="mt-3 pt-0"
          :label="translations.includeVat[lang]"
          hide-details
        ></v-checkbox>
        <b-select
          v-model="subscriptionPlan.interval"
          :items="['month', 'year']"
          :label="translations.interval[lang]"
        ></b-select>
        a {{ !!subscriptionPlan.interval_count }}a
        {{ success.interval_count }}
        <b-text-field
          v-model="subscriptionPlan.interval_count"
          :label="translations.intervalCount[lang]"
          type="number"
          :success="success.interval_count"
          :error-messages="error.interval_count"
          @focus="error.interval_count = ''"
          @blur="validateIntervalCount"
        >
        </b-text-field>

        <b-text-field
          v-model="subscriptionPlan.reward_points"
          :label="translations.rewardPoints[lang]"
          type="number"
          :success="success.reward_points"
          :error-messages="error.reward_points"
          @focus="error.reward_points = ''"
          @blur="validateRewardPoints"
        >
        </b-text-field>

        <b-select
          v-model="subscriptionPlan.reward_type_id"
          :items="rewardTypes"
          item-text="title"
          item-value="reward_type_id"
          :label="translations.rewardType[lang]"
          :success="success.reward_type"
          :error-messages="error.reward_type"
          @focus="error.reward_type = ''"
          @blur="validateRewardType"
        ></b-select>
        <!-- {{ paymentMethods }}
        {{ subscriptionPlan.store_payment_methods }} -->
        <b-select
          v-model="subscriptionPlan.store_payment_methods"
          :items="companyPaymentMethods"
          item-text="name"
          item-value="store_payment_method_id"
          :label="translations.paymentMethods[lang]"
          multiple
          :success="success.payment_methods"
          :error-messages="error.payment_methods"
          @focus="error.payment_methods = ''"
          @blur="validatePaymentMethods"
        ></b-select>

        <v-checkbox
          v-model="subscriptionPlan.is_public"
          color="secondary"
          class="mt-3 pt-0"
          hide-details="auto"
        >
          <template v-slot:label>
            <h4 class="secondary--text">
              {{ translations.publish[lang] }}
            </h4>
          </template>
        </v-checkbox>

        <v-checkbox
          v-model="subscriptionPlan.extra_properties.is_pos"
          color="secondary"
          class="mt-3 pt-0"
          hide-details="auto"
        >
          <template v-slot:label>
            <h4 class="secondary--text">POS</h4>
          </template>
        </v-checkbox>
        <div v-if="storeAttributes.length && subscriptionPlan.attributes" class="mt-4">
          <h3 class="secondary--text">
            {{ translations.attributes[lang] }}
          </h3>
          <div class="ml-3">
            <div v-for="(attribute, index) in storeAttributes" :key="index + attribute.title">
              <div v-if="attribute">
                <v-checkbox
                  v-model="checkedAttributes[attribute.title]"
                  color="secondary"
                  class="mt-3 pt-0"
                  hide-details="auto"
                >
                  <template v-slot:label>
                    <h4 class="secondary--text">
                      {{ attribute.name[lang] || attribute.name }}
                    </h4>
                  </template>
                </v-checkbox>
                <div
                  v-if="
                    checkedAttributes[attribute.title] && subscriptionPlanAttrs[attribute.title]
                  "
                >
                  <div
                    v-for="(optionKey, i) in Object.keys(attribute.options)"
                    :key="i + optionKey"
                    class="ml-3"
                  >
                    <template v-if="optionKey === 'kind'">
                      <b-select
                        v-model="subscriptionPlanAttrs[attribute.title]['kind']"
                        :items="attribute.options['kind']"
                        :label="attribute.name[lang]"
                        noClearIcon
                        :success="
                          success.kind &&
                          success.kind[attribute.title] &&
                          success.kind[attribute.title]['kind']
                        "
                        :error-messages="
                          error.kind &&
                          error.kind[attribute.title] &&
                          error.kind[attribute.title]['kind']
                        "
                        @change="validateOption(attribute, 'kind')"
                      ></b-select>
                    </template>
                    <template v-if="optionKey === 'double' || optionKey === 'integer'">
                      <template v-if="Array.isArray(attribute.options[optionKey])">
                        <b-text-field
                          v-for="(att, idx) in attribute.options[optionKey]"
                          :key="idx"
                          type="number"
                          :label="att"
                          v-model="subscriptionPlanAttrs[attribute.title][att]"
                          :success="
                            success[optionKey] &&
                            success[optionKey][attribute.title] &&
                            success[optionKey][attribute.title][att]
                          "
                          :error-messages="
                            error[optionKey] &&
                            error[optionKey][attribute.title] &&
                            error[optionKey][attribute.title][att]
                          "
                          @blur="validateOption(attribute, optionKey)"
                        />
                      </template>
                      <template v-else>
                        <b-text-field
                          type="number"
                          :label="attribute.options[optionKey]"
                          v-model="
                            subscriptionPlanAttrs[attribute.title][attribute.options[optionKey]]
                          "
                          :success="
                            success[optionKey] &&
                            success[optionKey][attribute.title] &&
                            success[optionKey][attribute.title][attribute.options[optionKey]]
                          "
                          :error-messages="
                            error[optionKey] &&
                            error[optionKey][attribute.title] &&
                            error[optionKey][attribute.title][attribute.options[optionKey]]
                          "
                          @blur="validateOption(attribute, optionKey)"
                        />
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col
        cols="12"
        class="subtitle-1 text--primary py-0 mt-4 ml-2"
        :class="{
          'mt-2': mode === 'create',
          'mb-2': mode === 'update',
        }"
      >
        <v-row no-gutters align="center">
          <h3 class="secondary--text">
            {{ this.translations.permissions[this.lang] }}
          </h3>
        </v-row>
      </v-col>

      <b-object-treeview class="pa-5" v-model="permissions" />
    </v-row>
  </b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import translations from '@/utils/translations/loyaltyPanel/subscriptions/registrationPlans';
import validators from '@/utils/validators/loyaltyPanel/subscriptionPlans';
import { mdiMenuRight, mdiMenuDown, mdiCheckboxBlankOutline, mdiCheckBoxOutline } from '@mdi/js';

export default {
  name: 'SubscriptionPlanForm',

  mixins: [validators, translations],

  props: {
    mode: String,
  },

  data() {
    return {
      nameLang: this.$route.params.lang,
      descriptionLang: this.$route.params.lang,
      price_type: 1,
      changeNameElAuto: true,
      changeNameItAuto: true,
      changeNameEnAuto: true,
      changeDescriptionElAuto: true,
      changeDescriptionItAuto: true,
      changeDescriptionEnAuto: true,
      checkedAttributes: {},
      subscriptionPlanAttrs: {},
      allPermissions: false,
      icons: {
        mdiMenuRight,
        mdiMenuDown,
        mdiCheckboxBlankOutline,
        mdiCheckBoxOutline,
      },
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'resetSuccess', 'resetValidation']),
    ...mapState('loyaltyPanel/subscriptions/paymentMethods', ['companyPaymentMethods']),
    ...mapState('loyaltyPanel/subscriptions/registrationPlans', ['storeAttributes']),

    planTypes() {
      return this.$store.state.loyaltyPanel.subscriptions.registrationPlans.planTypes;
    },

    rewardTypes() {
      return this.$store.state.loyaltyPanel.subscriptions.registrationPlans.rewardTypes;
    },

    lang() {
      return this.$route.params.lang;
    },

    title() {
      return this.mode === 'create'
        ? this.translations.modalTitle1[this.lang]
        : this.translations.modalTitle2[this.lang];
    },

    permissions: {
      get() {
        return this.$store.state.loyaltyPanel.subscriptions.registrationPlans.storePermissions;
      },
      set(val) {
        this.setStorePermissions(val);
      },
    },

    subscriptionPlan: {
      get() {
        return this.$store.state.loyaltyPanel.subscriptions.registrationPlans.subscriptionPlan;
      },
      set() {
        this.setSubscriptionPlan();
      },
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/subscriptions/registrationPlans', [
      'getStoreAttributes',
      'getStorePermissions',
      'getRewardTypes',
      'create',
      'update',
    ]),
    ...mapActions('loyaltyPanel/subscriptions/paymentMethods', ['getCompanyPaymentMethods']),
    ...mapMutations(['setDialog', 'setDeleteDialog', 'setResetSuccess', 'setResetValidation']),
    ...mapMutations('loyaltyPanel/subscriptions/registrationPlans', [
      'setSubscriptionPlan',
      'setStorePermissions',
    ]),
    ...mapMutations('loyaltyPanel/subscriptions/paymentMethods', ['setLanguage']),

    submit() {
      const checkedAttribute = Object.values(this.checkedAttributes).find((attr) => attr);
      if (!checkedAttribute) {
        this.subscriptionPlan.attributes = {};
      } else {
        this.subscriptionPlan.attributes = {
          ...this.subscriptionPlanAttrs,
        };
        Object.keys(this.subscriptionPlan.attributes).forEach((key) => {
          if (!this.checkedAttributes[key]) {
            delete this.subscriptionPlan.attributes[key];
          }
        });
      }
      this.create();
    },

    updateSubscription() {
      const checkedAttribute = Object.values(this.checkedAttributes).find((attr) => attr);
      if (!checkedAttribute) {
        this.subscriptionPlan.attributes = {};
      } else {
        this.subscriptionPlan.attributes = {
          ...this.subscriptionPlanAttrs,
        };
        Object.keys(this.subscriptionPlan.attributes).forEach((key) => {
          if (!this.checkedAttributes[key]) {
            delete this.subscriptionPlan.attributes[key];
          }
        });
      }
      this.update();
    },
    initializeAttributes() {
      let checkedAttributesKeys = Object.keys(this.checkedAttributes || {});
      if (!checkedAttributesKeys?.length) {
        this.$set(this, 'subscriptionPlanAttrs', {});
        return;
      }
      this.storeAttributes.forEach((e) => {
        Object.keys(e.options).forEach((optionKey) => {
          if (!this.valid[optionKey]) this.$set(this.valid, optionKey, {});
          if (!this.success[optionKey]) this.$set(this.success, optionKey, {});
          if (!this.error[optionKey]) this.$set(this.error, optionKey, {});

          if (!this.valid[optionKey][e.title]) this.$set(this.valid[optionKey], e.title, {});
          if (!this.success[optionKey][e.title]) this.$set(this.success[optionKey], e.title, {});
          if (!this.error[optionKey][e.title]) this.$set(this.error[optionKey], e.title, {});

          let keys = Array.isArray(e.options[optionKey])
            ? e.options[optionKey]
            : [e.options[optionKey]];

          keys.forEach((key) => {
            this.$set(this.valid[optionKey][e.title], key, !this.checkedAttributes[e.title]);
            this.$set(this.success[optionKey][e.title], key, !this.checkedAttributes[e.title]);
            this.$set(this.error[optionKey][e.title], key, '');
          });
        });
      });
      for (let attrTitle of checkedAttributesKeys) {
        if (this.checkedAttributes[attrTitle] && !this.subscriptionPlanAttrs[attrTitle]) {
          let attribute = this.storeAttributes.find((attr) => attr.title === attrTitle);
          if (attribute?.title) {
            this.$set(this.subscriptionPlanAttrs, attribute.title, {});
            for (let option in attribute.options) {
              if (option === 'kind') {
                this.$set(
                  this.subscriptionPlanAttrs[attribute.title],
                  'kind',
                  this.subscriptionPlan?.attributes?.[attribute.title]?.kind ||
                    attribute.options['kind'][0]
                );
              } else {
                let optionValue = attribute.options[option];
                if (typeof optionValue === 'string') {
                  optionValue = [attribute.options[option]];
                }
                if (Array.isArray(optionValue)) {
                  for (let val of optionValue) {
                    this.$set(
                      this.subscriptionPlanAttrs[attribute.title],
                      val,
                      this.subscriptionPlan?.attributes?.[attribute.title]?.[val] || ''
                    );
                  }
                }
              }
            }
          }
        } else if (!this.checkedAttributes[attrTitle] && this.subscriptionPlanAttrs[attrTitle]) {
          delete this.subscriptionPlanAttrs[attrTitle];
        }
      }
    },
  },

  async mounted() {
    await this.getStoreAttributes();
    await this.getStorePermissions();
    this.setLanguage(this.lang);
    this.getCompanyPaymentMethods();
    this.getRewardTypes();
  },

  watch: {
    mode(val) {
      if (val === 'create') {
        this.getStorePermissions();
      }
    },

    ['subscriptionPlan.store_subscription_plan_id']: {
      immediate: true,
      handler(val) {
        this.$set(this, 'checkedAttributes', {});
        for (let attrTitle in this.subscriptionPlan?.attributes || {}) {
          this.$nextTick(() => {
            this.$set(this.checkedAttributes, attrTitle, true);
          });
        }
      },
    },

    ['storeAttributes']: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.length) {
          this.initializeAttributes();
        }
      },
    },

    ['subscriptionPlan.system_subscription_plan_payment_type_id']: {
      immediate: true,
      handler(val) {
        if (val) {
          if (val == 1) {
            this.price_type = 1;
          } else if (val == 2) {
            this.price_type = 2;
          }
        }
      },
    },

    ['$route.params.lang'](val) {
      this.nameLang = val;
      this.descriptionLang = val;
    },

    ['subscriptionPlan.plan_name.en'](val) {
      if (this.lang == 'en') {
        if (this.changeNameElAuto) {
          this.subscriptionPlan.plan_name.el = val;
        }

        if (this.changeNameItAuto) {
          this.subscriptionPlan.plan_name.it = val;
        }

        this.changeNameEnAuto = false;
      } else if (val != this.subscriptionPlan.plan_name[this.lang]) {
        this.changeNameEnAuto = false;
      }
    },

    ['subscriptionPlan.plan_name.el'](val) {
      if (this.lang == 'el') {
        if (this.changeNameEnAuto) {
          this.subscriptionPlan.plan_name.en = val;
        }

        if (this.changeNameItAuto) {
          this.subscriptionPlan.plan_name.it = val;
        }

        this.changeNameElAuto = false;
      } else if (val != this.subscriptionPlan.plan_name[this.lang]) {
        this.changeNameElAuto = false;
      }
    },

    ['subscriptionPlan.plan_name.it'](val) {
      if (this.lang == 'it') {
        if (this.changeNameElAuto) {
          this.subscriptionPlan.plan_name.el = val;
        }

        if (this.changeNameEnAuto) {
          this.subscriptionPlan.plan_name.en = val;
        }

        this.changeNameItAuto = false;
      } else if (val != this.subscriptionPlan.plan_name[this.lang]) {
        this.changeNameItAuto = false;
      }
    },

    ['subscriptionPlan.plan_description.en'](val) {
      if (this.lang == 'en') {
        if (this.changeDescriptionElAuto) {
          this.subscriptionPlan.plan_description.el = val;
        }

        if (this.changeDescriptionItAuto) {
          this.subscriptionPlan.plan_description.it = val;
        }

        this.changeDescriptionEnAuto = false;
      } else if (val != this.subscriptionPlan.plan_description[this.lang]) {
        this.changeDescriptionEnAuto = false;
      }
    },

    ['subscriptionPlan.plan_description.el'](val) {
      if (this.lang == 'el') {
        if (this.changeDescriptionEnAuto) {
          this.subscriptionPlan.plan_description.en = val;
        }

        if (this.changeDescriptionItAuto) {
          this.subscriptionPlan.plan_description.it = val;
        }

        this.changeDescriptionElAuto = false;
      } else if (val != this.subscriptionPlan.plan_description[this.lang]) {
        this.changeDescriptionElAuto = false;
      }
    },

    ['subscriptionPlan.plan_description.it'](val) {
      if (this.lang == 'it') {
        if (this.changeDescriptionElAuto) {
          this.subscriptionPlan.plan_description.el = val;
        }

        if (this.changeDescriptionEnAuto) {
          this.subscriptionPlan.plan_description.en = val;
        }

        this.changeDescriptionItAuto = false;
      } else if (val != this.subscriptionPlan.plan_description[this.lang]) {
        this.changeDescriptionItAuto = false;
      }
    },

    checkedAttributes: {
      deep: true,
      handler(val) {
        this.initializeAttributes();
      },
    },
  },
};
</script>
